<template>
  <div class="container">
    <news-info api="News_Info" :params="params" />
  </div>
</template>

<script>
import NewsInfo from "@/components/NewsInfo";

export default {
  components: {
    NewsInfo
  },
  data() {
    return {
      params: {}
    };
  },
  created() {
    this.params = this.$route.query;
  },
  methods: {}
};
</script>
